// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldSettings2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '20',
      height: '20',
      viewBox: '0 0 20 20',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.1 7.21945C16.29 7.21945 15.55 5.93945 16.45 4.36945C16.97 3.45945 16.66 2.29945 15.75 1.77945L14.02 0.789448C13.23 0.319448 12.21 0.599448 11.74 1.38945L11.63 1.57945C10.73 3.14945 9.25 3.14945 8.34 1.57945L8.23 1.38945C7.78 0.599448 6.76 0.319448 5.97 0.789448L4.24 1.77945C3.33 2.29945 3.02 3.46945 3.54 4.37945C4.45 5.93945 3.71 7.21945 1.9 7.21945C0.86 7.21945 0 8.06945 0 9.11945V10.8794C0 11.9194 0.85 12.7794 1.9 12.7794C3.71 12.7794 4.45 14.0594 3.54 15.6294C3.02 16.5394 3.33 17.6994 4.24 18.2194L5.97 19.2094C6.76 19.6794 7.78 19.3995 8.25 18.6094L8.36 18.4194C9.26 16.8494 10.74 16.8494 11.65 18.4194L11.76 18.6094C12.23 19.3995 13.25 19.6794 14.04 19.2094L15.77 18.2194C16.68 17.6994 16.99 16.5294 16.47 15.6294C15.56 14.0594 16.3 12.7794 18.11 12.7794C19.15 12.7794 20.01 11.9294 20.01 10.8794V9.11945C20 8.07945 19.15 7.21945 18.1 7.21945ZM10 13.2494C8.21 13.2494 6.75 11.7894 6.75 9.99945C6.75 8.20945 8.21 6.74945 10 6.74945C11.79 6.74945 13.25 8.20945 13.25 9.99945C13.25 11.7894 11.79 13.2494 10 13.2494Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldSettings2 };
